/**
 * Created by sswaminathan on 10/11/22
 * File: SingleTenantRegionDropDown
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

import { Body } from '@panwds/react-ui'
/**
 *   TODO: Brief what is this component/class do
 */
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import {
  APP_ID_BACKBONE,
  APP_ID_LOGGING_SERVICE,
  APP_ID_PAN_CHINA,
  APP_ID_PANORAMA,
  APP_ID_PRISMA_ACCESS,
  APP_ID_PRISMA_ACCESS_PANORAMA,
  ENTERPRISE_FLOW_APPS
} from '../../../../../common/constants/GlobalConstants'
import RegionDropDown from '../../../../../common/region/RegionDropDown'
import { ARRAY, isNonemptyArray } from '../../../../../common/utils/Utils'
import { CHINA_REGION, SASE_SELECT_REGION, SELECT_REGION } from '../../../../constants/LabelConstants'
import { ADD_NEW } from '../../../constants/SubscriptionConstant'
import DropDown from '../../../dropdown/DropDown'
import ProductRegions from '../../../licenseProducts/ProductRegions'

const SingleTenantRegionDropDown = (props) => {
  const { setValue, watch, getValues } = useFormContext()
  const {
    licenseContext,
    licenses,
    apps,
    setPanorama,
    supportedRegions,
    loading,
    setAppRegions,
    selectedTSGInstances,
    migrateCDLFromCSP,
    appRegions } = props
  const [regionDisabled, setRegionDisabled] = useState(false)
  const [instanceRegion, setInstanceRegion] = useState()
  const isCloudManaged = watch('platform')
  const cspAccount = watch('support_account')
  const cdlInstance = watch('cdl')

  const updateInstanceRegion = useCallback(() => {
    const tsg_id = getValues('tsg')
    if (tsg_id?.id !== ADD_NEW && isNonemptyArray(selectedTSGInstances)) {
      if (selectedTSGInstances?.get(APP_ID_BACKBONE) && selectedTSGInstances?.length === 1) {
        setInstanceRegion(null)
      }
      else {
        const _appInstance = selectedTSGInstances.find((each) => each.platform_region && each.region !== 'global')
        setInstanceRegion(_appInstance?.platform_region ?? selectedTSGInstances.get(APP_ID_LOGGING_SERVICE)?.region)
      }
    }
  }, [getValues, selectedTSGInstances])

  useEffect(() => {
    const tsg_id = getValues('tsg')
    if (tsg_id?.id === ADD_NEW || !isNonemptyArray(selectedTSGInstances)) {
      setInstanceRegion('')
    }
    else {
      updateInstanceRegion()
    }
  }, [getValues, selectedTSGInstances, setInstanceRegion, updateInstanceRegion])

  useEffect(() => {
    if (migrateCDLFromCSP) {
      if (cdlInstance?.migrate && cdlInstance?.region) {
        setInstanceRegion(cdlInstance.region)
      }
      else {
        setInstanceRegion('')
        updateInstanceRegion()
      }
    }
  }, [cdlInstance, migrateCDLFromCSP, updateInstanceRegion])

  const regionLabel = useMemo(() => {
    return ENTERPRISE_FLOW_APPS.has(licenseContext) ? SELECT_REGION : SASE_SELECT_REGION
  }, [licenseContext])

  const regions = useMemo(() => {
    const addID = (array, app_id) => {
      const id = app_id.startsWith(APP_ID_PRISMA_ACCESS) ? (isCloudManaged ? APP_ID_PRISMA_ACCESS : APP_ID_PRISMA_ACCESS_PANORAMA) : app_id
      if (!array.includes(id)) {
        array.push(id)
      }
    }
    // TODO: warning, this is using Fawkes region list even though when panorama managed
    const appIdList = licenses.reduce((array, license) => {
      if (apps[license.app_id]) {
        addID(array, license.app_id)
      }
      if (ARRAY.hasArray(license.entitlements)) {
        license.entitlements.forEach(app => {
          addID(array, app.app_id)
        })
      }
      return array
    }, []).filter(each => each !== APP_ID_PANORAMA)

    const isPaChina = appIdList?.some((each) => each === APP_ID_PAN_CHINA)
    if (isPaChina) {
      setRegionDisabled(isPaChina)
      setPanorama({ isPanoramaLocked: true })
    }
    const regionDropDown = RegionDropDown(appIdList, supportedRegions, true, cspAccount?.id)
    setValue('region_name', regionDropDown.find((each) => {
      return each.id === (isPaChina ? CHINA_REGION : instanceRegion)
    }))
    return regionDropDown
  }, [licenses, supportedRegions, cspAccount?.id, setValue, isCloudManaged, apps, setPanorama, instanceRegion])

  const onRegionChange = useCallback((change) => {
    if (change?.target?.value?.additional_region_mapping) {
      setAppRegions(change?.target?.value?.additional_region_mapping)
    }
    else {
      setAppRegions({})
    }
  }, [setAppRegions])

  return <>
    <div>
      <DropDown
        addClassName='cmm-modal-select'
        itemList={regions}
        fieldName='region_name'
        label={<Body addClassName="tw-font-lato tw-italic" as="span">{regionLabel}</Body>}
        height={null}
        width="100%"
        errorLabel={regionLabel}
        required={true}
        changeHandler={onRegionChange}
        selectProps={{
          label: regionLabel,
          showLabel: false,
          defaultValue: regions[0],
          disabled: loading || instanceRegion || regionDisabled,
          fullWidth: true
        }}
      />
    </div>
    {(Object.keys(appRegions)?.length) ? Object.keys(appRegions).map((each, index) => {
      return <ProductRegions
        key={index}
        {...{
          appRegion: appRegions[each],
          appName: each,
          licenseValue: '',
          height: 'null',
          width: '100%'
        }} />
    }) : <></>}
  </>
}

SingleTenantRegionDropDown.propTypes = {}
export default SingleTenantRegionDropDown
